import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
import { Alert, Row, Col, Collapse } from "antd";
import BackgroundSetting from "Components/BackgroundSetting";
import subjectDefaultData from "Pub/js/subjectDefaultData";
import HotKeysModal from "Components/HotKeysModal";
import {
    changeDrawer,
    setDisturbMode,
    changeIsAccountSettingSpr,
    changeBgState,
    setThemeColor,
} from "Store/appStore/action";
import Notice from "Components/Notice";
import Ajax from "Pub/js/ajax";
import classNames from "classnames";
import { getMulti } from "Pub/js/getMulti";
import { openPage } from "Pub/js/superJump";
import {
    langCheck,
    GetQuery,
    getAvatarName,
    setThemeAndIframe,
    getDefaultClassName,
    getCustomTheme,
    setBodyClass,
    setIframeZoom,
    setNccFontSize,
} from "Pub/js/utils";
import { setStore, getStore } from "Pub/js/storageUtils";
import backgroundImgs from "Pub/js/backgroundImg";
import moment from "moment";
import selectIcon from 'Assets/images/select-icon.svg';
import bannerImg from 'Assets/images/accountSettingBanner.png';
import bannerBlack from 'Assets/images/accountSettingBannerBlack.png';
import platform from "Pub/js/platform";
const { promptBox, PubSub, formatDatetime } = platform;
const { NCSelect, NCCheckbox, NCSwitch } = platform.base;
const dateFormat = "YYYY-MM-DD HH:mm:ss";
const { NCOption } = NCSelect;
const { Panel } = Collapse;
import defaultLightSmall from 'Assets/images/default-light-small.svg';
import defaultDepthSmall from 'Assets/images/default-depth-small.svg';
import AvatarImg from "Components/AvatarImg";
import ThemeColor from 'Components/ThemeColor';
import GroupSelection from "../headerComponents/GroupSelection";
import Browser from 'Pub/js/browser';
import { getBackgroundObject } from "../../pages/CompanyStyleSetting/common";

const {
    colorMap,
    showColorMap,
    bgImgArr,
    bgColorArr,
    bgColorMap,
    defaultBackgroundObject,
    defaultLight,
    defaultDepth,
    colorNameObject,
    getColorArr,
} = subjectDefaultData;

/**
 * 是否开启勿扰模式 isopen;
 * 是否同时开启暗色模式 isdark;
 * 生效时间  entrytime;
 * 到期时间 duetime;
 */
class AccountSettings extends React.Component {
    constructor(props) {
        super(props);
        this.checkedTheme = props.theme; // 当前选中主题
        this.state = {
            checkedColor: props.theme.color,
            updateState: false,
            disturbVis: false, //弹窗显隐性
            colorArr: this.getDefaultColorArr(),
            colorNameMap: {
                "": langCheck("0000PUB-000282") /* 国际化处理： 默认*/,
                "#F1F1F1": langCheck("0000PUB-000282") /* 国际化处理： 默认*/,
                [defaultLight]: langCheck("0000PUB-000484") /* 国际化处理： 默认浅*/,
                [defaultDepth]: langCheck("0000PUB-000485") /* 国际化处理： 默认深*/,
                "#BF381A": langCheck("0000PUB-000283") /* 国际化处理： 典雅红*/,
                "#1561CD": langCheck("0000PUB-000284") /* 国际化处理： NC蓝*/,
                "#138346": langCheck("0000PUB-000285") /* 国际化处理： 舒眼绿*/,
                "#A47238": langCheck("0000PUB-000286") /* 国际化处理： 跃动黄*/,
                "#2E2C2C": langCheck("0000PUB-000287"), /* 国际化处理： 暗夜黑*/
            },
            bgImgArr: bgImgArr,
            bgColorArr: bgColorArr,
            backgroundObject: defaultBackgroundObject,
            json: {},
            collapseValue: 'skinPanel',
            usermodify: null, // 用户是否有权限设置主题皮肤 默认为 null
            zoomVal: getStore('zoom') || 1, // 缩放
        };
        this.initThemeColor = getStore("nccColor"); //打开Drawer时候的主题色
    }

    getDefaultColorArr = () => {
        const { theme } = this.props;
        const colorArr = getColorArr();
        const checked = colorArr.find(item => item.color === theme.color);
        if (checked) { // 默认选中当前生效的主题
            colorArr.forEach(item => item.defaultShow = false);
            checked.defaultShow = true;
        }
        return colorArr;
    }

    handleChange = value => {
        this.setState({ selectedValue: value });
    }

    componentDidMount() {
        const { colorArr } = this.state;
        this.setDisturbInfo();
        this.getDefaultColor();
        this.getUsermodify(); // 获取个人是否有权限修改
        let callback = json => {
            this.setState({ json: json });
        };
        getMulti({
            moduleId: "Customize",
            domainName: "workbench",
            callback,
        });
        // 更新页面为了拿到local的showspr
        this.setState({ update: true });
        document.addEventListener(
            "visibilitychange",
            this.handleVisibilityChange,
        );
        this.RationChange = PubSub.subscribe('zoomChange', (action, zoom) => {
            this.handleScreenRationChange(zoom);
        });
    }

    componentDidUpdate(prevProps) {
        const { visible } = this.props;
        if (prevProps.visible !== visible) {
            //打开drawer时记录一下主题色
            if (visible) {
                this.initThemeColor = getStore("nccColor");
            } else {
                //收起Drawer时主题色有修改同步给BIP
                if (this.initThemeColor !== getStore("nccColor")) {
                    this.syncBipTheme();
                }
            }
        }
    }
    componentWillUnmount() {
        document.removeEventListener(
            "visibilitychange",
            this.handleVisibilityChange,
        );
        PubSub.unsubscribe(this.RationChange);
    }

    //根据缩放比例调整界面
    handleScreenRationChange = zoom => {
        console.log(zoom);
        this.setState({ zoomVal: zoom });
    }
    handleVisibilityChange = () => {
        this.setState({ update: true });
    };
    // 设置 colorarr
    setColorArr = (color, customColors) => {
        let { colorArr } = this.state;
        if (customColors) { // 拼接自定义主题数据
            colorArr = colorArr.concat(customColors);
        }
        const { pk_customtheme } = this.checkedTheme;
        colorArr.map(e => {
            e.defaultShow = e.pk_customtheme === pk_customtheme && e.color == color;
        });
        this.setState({ colorArr });
    }
    // 获取主题接口
    getDefaultColor = () => {
        const { groupId, theme } = this.props;
        Ajax({
            url: "/nccloud/platform/appregister/querythemecolor.do",
            data: {},
            noNeedShowError: true,
            success: async ({ data: { data, success } }) => {
                if (success && data) {
                    this.checkedTheme = data;
                    const customColors = await getCustomTheme({ pk_group: groupId });
                    if (data.isDefault || data.customtheme_del) {
                        // TODO
                        // 当用户未设置主题时 默认选中的颜色需要与目前生效的主题保持一致 
                        // const { color = defaultLight } = data;
                        let nccColor = getStore('nccColor');
                        if (nccColor) {
                            nccColor = nccColor === 'mixin' ? theme.color : colorNameObject[nccColor];
                            this.checkedTheme.pk_customtheme = theme.pk_customtheme; // 设置选中效果的时候会用到pk_customtheme来区分是否为自定义
                            this.setState({ checkedColor: nccColor, backgroundObject: defaultBackgroundObject });
                            this.setColorArr(nccColor, customColors);
                        }
                    } else {
                        let { bdcolor = "gray", color: selectColor } = data;
                        let { bgColorArr } = this.state;
                        // 默认分为 默认浅 默认深 为了兼容之前存的默认值
                        if (selectColor === '#F1F1F1') {
                            selectColor = defaultLight;
                        }
                        let newBgColor = '';
                        if (bgColorMap[bdcolor]) {
                            newBgColor = bgColorMap[bdcolor];
                            bgColorArr.map(item => {
                                item.defaultShow = false;
                                if (item.name === bdcolor) {
                                    item.defaultShow = true;
                                    item.color = newBgColor;
                                }
                                return item;
                            });
                        } else if (!bgColorMap[bdcolor]) {
                            newBgColor = bdcolor;
                            bgColorArr.map(item => {
                                item.defaultShow = false;
                                if (item.name === 'sketch') {
                                    item.defaultShow = true;
                                    item.color = newBgColor;
                                }
                                return item;
                            });
                        }
                        const backgroundObject = getBackgroundObject(data);
                        this.setColorArr(selectColor, customColors);
                        this.setState({ checkedColor: selectColor, backgroundObject, bgColorArr });
                    }
                }

            },
        });
    }

    // 回写勿扰模式设置信息
    setDisturbInfo = () => {
        // 获取勿扰模式信息
        Ajax({
            url: "/nccloud/platform/appregister/querydistrub.do",
            data: {},
            info: {
                name: langCheck("0000PUB-000333") /* 国际化处理： 勿扰模式*/,
                action: langCheck("0000PUB-000335"), /* 国际化处理： 勿扰模式查询*/
            },
            success: ({ data }) => {
                if (data.success && data.data) {
                    let Info = data.data;
                    // if (getStore("nccColor") && getStore("nccColor") === "black") {
                    //     Info.isdark = true;
                    // }
                    this.props.setDisturbMode(Info);
                }
            },
        });
    };
    // 弹窗取消
    disturbCancel = () => {
        this.setState({ disturbVis: false });
    };
    // 复选框
    checkboxChange = val => {
        let { disturbInfo } = this.props;
        disturbInfo.isdark = val;
        this.props.setDisturbMode(disturbInfo);
    };
    // 选择框
    selectChange = v => {
        let { disturbInfo } = this.props;
        disturbInfo.entrytime = v;
        this.props.setDisturbMode(disturbInfo);
    };
    /**
     * 侧边栏当前页跳转页面
     * 采用单页路由方式
     * @param {Object} param 跳转目标页需要传递的参数
     * @param {String} uri 跳转目标页面路由
     */
    handeleSkipPage = (uri, param) => {
        let { n } = GetQuery(this.props.location.search);

        if (n && n !== "null" && this.props.location.pathname !== "/") {
            // 其他页面跳转
            openPage(uri, true, param, ["ar", "ifr", "b1", "b2", "b3"]);
        } else {
            // 首页跳转
            openPage(uri, false, param, ["b1", "b2", "b3"]);
        }
        this.props.changeDrawer(false);
    };
    /**
     * 注销操作
     */
    handleExit = () => {
        this.props.changeDrawer(false);
        promptBox({
            color: 'warning',
            title: langCheck("0000PUB-000370") /* 国际化处理： 退出*/,
            content: langCheck("0000PUB-000141") /* 国际化处理： 确定要退出当前账号吗？ */,
            beSureBtnClick: () => {
                window.onbeforeunload = null;
                window.proxyAction &&
                    window.proxyAction(
                        window.logout,
                        this,
                        langCheck("0000PUB-000370"),
                    )({ logout: true }); /* 国际化处理： 注销*/
            },
            container: document.body
        });
    };
    /**
     * 联系用友服务人员
     */
    sysinitAccessorAction = () => {
        let { hostname, port, protocol } = window.location;
        Ajax({
            url: `/nccloud/platform/login/loginism.do`,
            data: {
                ip: hostname,
                port: port.length > 0 ? port : "80",
            },
            info: {
                name: langCheck("0000PUB-000105") /* 国际化处理： 首页*/,
                appcode: "10228888",
                action: langCheck("0000PUB-000142"), /* 国际化处理： 联系服务人员*/
            },
            success: ({ data: { data } }) => {
                let regx = /^(http(s)?:)(\/\/)(.*)/;
                let url;
                if (data) {
                    url = regx.exec(data) ? data : `${protocol}//${data}`;
                    window.open(url, '_blank');
                } else {
                    this.props.changeDrawer(false);
                    Notice({
                        status: "error",
                        msg: langCheck("0000PUB-000143"), /* 国际化处理： 请联系系统管理员配置本地ism服务器ip地址！*/
                    });
                }
            },
            error: () => {
                this.props.changeDrawer(false);
            },
        });
    };

    //打开工单系统
    handleOpenWorkOrder = () => {
        Ajax({
            url: "/nccloud/platform/login/openygd.do",
            info: {
                name: langCheck("0000PUB-000309") /* 国际化处理： 工单系统*/,
                appcode: "10228888",
                action: langCheck("0000PUB-000310"), /* 国际化处理： 打开工单系统*/
            },
            success: function ({ data: { data } }) {
                let regx = /^(http(s)?:)(\/\/)(.*)/;
                let url;
                if (data) {
                    url = regx.exec(data) ? data : `${protocol}//${data}`;
                    window.open(data, '_blank');
                }
            },
        });
    };

    //服务支持跳转
    handleSupportClick = () => {
        //云环境打开云工单
        // if (this.props.is_cloud_register) {
        //     this.handleOpenWorkOrder();
        // } else {
            this.sysinitAccessorAction();
        // }
    };
    // 应用导航
    onAppNavClick = () => {
        // window.open('/nccloud/resources/uap/appnav/page/main/index.html?readonly=true', '_blank');
        // NCC-70932 客户特殊需求，小应用节点面包屑需要移仓层级结构，
        // 这不符合小应用原先的规则，所以需要扩展一个处理返回数据的方法，支持该需求
        const AppNavCode = '10164503';
        window.openNew({ appcode: AppNavCode }, null, null, {
            openTabWithoutCheck: false,
            mapDataFn: {
                menu: langCheck('0000PUB-000377')
            },
        });
        this.props.changeDrawer(false);
    }
    // 勿扰模式开关
    switchChange = async checked => {
        let { disturbInfo } = this.props;
        disturbInfo.isopen = checked;
        // 需要重新计算到期时间
        disturbInfo.entrytime = disturbInfo.entrytime || 0.5;
        disturbInfo.duetime = this.getSetTime(disturbInfo.entrytime);
        await this.props.setDisturbMode(disturbInfo);
        this.disturbInfoCommit("switch");
    };
    // 弹窗确认
    disturbOk = async () => {
        let { disturbInfo } = this.props;
        disturbInfo.duetime = this.getSetTime(disturbInfo.entrytime);
        await this.props.setDisturbMode(disturbInfo);
        this.setState(
            { disturbVis: false },
            () => {
                this.disturbInfoCommit("modal");
            },
        );
    };
    // 调取勿扰模式接口
    disturbInfoCommit = type => {
        let { disturbInfo } = this.props;
        const { isopen, isdark, entrytime, pk_distutb, duetime } = disturbInfo;
        const { json } = this.state;
        let data = {
            isopen: isopen ? isopen : false,
            isdark: isdark ? isdark : false,
            entrytime: entrytime || "0.5", //容错处理
            duetime:
                duetime ||
                moment()
                    .add("0.5", "hours")
                    .format(dateFormat), //容错处理
            pk_distutb: pk_distutb ? pk_distutb : null,
        };
        Ajax({
            url: "/nccloud/platform/appregister/savedistrub.do",
            data: data,
            info: {
                name: langCheck("0000PUB-000333") /* 国际化处理： 勿扰模式*/,
                action: langCheck("0000PUB-000334"), /* 国际化处理： 勿扰模式设置*/
            },
            success: ({ data }) => {
                if (data.success && data.data) {
                    let Info = data.data;
                    //控制IM及消息提示
                    this.props.setDisturbMode(Info);
                    this.props.getDistubInfo && this.props.getDistubInfo(false);
                    // 提示
                    if (type === 'switch') {
                        if (Info.isopen) {
                            Notice({
                                status: "success",
                                msg: langCheck("Customize-000050", "pages", json), //多语 启用成功
                            });
                            // if (Info.isdark && window.nccColor !== "black") {
                            //     this.setDarkMode();
                            // }
                        } else {
                            Notice({
                                status: "success",
                                msg: langCheck("Customize-000051", "pages", json), //多语 停用成功
                            });
                            // if (!Info.isdark && window.nccColor == 'black') {
                            //     this.setDefault();
                            //     this.setState({
                            //         checkedColor: '#F1F1F1'
                            //     })
                            // }
                        }
                    } else {
                        Notice({
                            status: "success",
                            msg: langCheck("Customize-000052", "pages", json), //多语 已成功
                        });
                        // if (isopen) {
                        //     // 先开启勿扰模式 再 同时开启暗色模式 确实之后 暗黑主题要生效
                        //     this.setDarkMode();
                        // }
                    }

                }
            },
        });
    };
    // 暗黑模式
    // setDarkMode = () => {
    //     const icon = getStore("nccIcon") || "";
    //     const table = getStore("nccTable");
    //     let tableType, crossCheck, cuttingCheck;
    //     if (table) {
    //         tableType = table.tableType;
    //         crossCheck = table.crossCheck;
    //         cuttingCheck = table.cuttingCheck;
    //     } else {
    //         tableType = "compact";
    //         crossCheck = false;
    //         cuttingCheck = true;
    //     }
    //     const { pk_customtheme } = this.checkedTheme;

    //     Ajax({
    //         url: "/nccloud/platform/appregister/addthemecolor.do",
    //         data: {
    //             color: "#2E2C2C",
    //             icon: icon,
    //             tabletype: tableType,
    //             crossCheck: crossCheck,
    //             cuttingCheck: cuttingCheck,
    //             name: langCheck("0000PUB-000287"),
    //             defaultshow: true,
    //             checked: true,
    //             pk_customtheme,
    //         },
    //         info: {
    //             name: langCheck("0000PUB-000258") /* 国际化处理： 主题设置*/,
    //             action: langCheck("0000PUB-000340"), /* 国际化处理： 回写主题设置*/
    //         },
    //         noNeedShowError: true,
    //         success: ({ data }) => {
    //             if (data.success && data.data) {
    //                 const nccColor = pk_customtheme ? 'mixin' : colorMap["#2E2C2C"];
    //                 const { fontSize, name, color } = data.data;
    //                 window.nccColor = "black";
    //                 // 更换plantform.css
    //                 setThemeAndIframe('black');

    //                 setNccFontSize(fontSize);
    //                 // 更换body class
    //                 setBodyClass({ themeType: 'black' });
    //                 // localStorage存颜色
    //                 setStore("nccColor", "black");
    //                 this.setState({ checkedColor: "#2E2C2C" });
    //                 this.setColorArr("#2E2C2C");
    //                 this.props.setThemeColor({ type: nccColor, name, color, pk_customtheme }); //设置 store主题色
    //             }
    //             // } else {
    //             //     this.setDefault();
    //             // }
    //         },
    //     });
    // };
    // 设置默认主题
    setDefault = () => {
        if (window.nccColor && window.nccColor !== "") {
            const icon = getStore("nccIcon") || "";
            const table = getStore("nccTable");
            let tableType, crossCheck, cuttingCheck;
            if (table) {
                tableType = table.tableType;
                crossCheck = table.crossCheck;
                cuttingCheck = table.cuttingCheck;
            } else {
                tableType = "compact";
                crossCheck = false;
                cuttingCheck = true;
            }
            const { bdtype, bgColor, blurNumber, bgImg } = defaultBackgroundObject;
            Ajax({
                url: "/nccloud/platform/appregister/addthemecolor.do",
                data: {
                    color: "#F1F1F1",
                    icon: icon,
                    tabletype: tableType,
                    crossCheck: crossCheck,
                    cuttingCheck: cuttingCheck,
                    name: langCheck("0000PUB-000282"),
                    defaultshow: true,
                    checked: true,
                    bdtype, //背景设置类型
                    bdpicture: bgImg, //背景图片
                    bdpicdim: blurNumber, //背景图片模糊值
                    bdcolor: bgColor, //背景颜色
                },
                info: {
                    name: langCheck("0000PUB-000258") /* 国际化处理： 主题设置*/,
                    action: langCheck("0000PUB-000340"), /* 国际化处理： 回写主题设置*/
                },
                noNeedShowError: true,
                success: ({ data }) => {
                    if (data.success && data.data) {
                        const { fontSize } = data.data;
                        window.nccColor = "";
                        setNccFontSize(fontSize);
                        // 更换plantform.css
                        setThemeAndIframe('default');
                        // 更换body class
                        setBodyClass({ themeType: 'default' });
                        // localStorage存颜色
                        setStore("nccColor", "");
                    }
                },
            });
        }
    };
    // 获取到期的时间
    getSetTime = entrytime => {
        if (!entrytime) {
            entrytime = "0.5";
        }
        let setTime = moment()
            .add(entrytime, "hours")
            .format(dateFormat);
        return setTime;
    };
    // 主题皮肤
    skinBox = data => {
        const { checkedColor, colorArr } = this.state;
        return (
            <ThemeColor
                checkedColor={checkedColor}
                setSubjectSkin={this.setSubjectSkin}
                colorArr={colorArr}
                type='accountSetting'
            />
            //     < ul className="panel-ul" >
            //         {
            //             data.map(item => {
            //                 const { color, fieldid, name } = item;
            //                 return <li className='panel-ul-li' key={item.key} onClick={this.setSubjectSkin.bind(this, color)} fieldid={fieldid}>
            //                     <div className={checkedColor === color ? "select-bg li-top" : "li-top"} >
            //                         <div
            //                             className="li-top-bg"
            //                             style={color.indexOf('default') !== -1 ? { background: `url(${showColorMap[color]}) center center` } : {
            //                                 backgroundColor: showColorMap[color],
            //                             }}
            //                         >
            //                             {checkedColor === color && <img className="select-icon" src={selectIcon} alt="" />}
            //                         </div>
            //                     </div>
            //                     <span className={`name ${checkedColor === color ? 'name-select' : ''}`}>{name}</span>
            //                 </li>
            //             }
            //             )
            //         }
            //     </ul >
        );
    }
    // 背景设置
    getBgSetting = () => {
        const { bgImgArr, bgColorArr, backgroundObject, updateState } = this.state;
        return (
            <BackgroundSetting
                bgImgArr={bgImgArr}
                bgColorArr={bgColorArr}
                getBgColorArr={this.getBgColorArr}
                getBackgroundObj={this.getBackgroundObj}
                getBackgroundObjAndAjax={this.getBackgroundObjAndAjax}
                backgroundObject={backgroundObject}
                updateState={updateState}
                bgType='accountSetting'
            />
        );
    }
    //设置主题皮肤方法
    setSubjectSkin = theme => {
        const { usermodify, colorArr } = this.state;
        const { color: checkedColor } = theme;
        if (usermodify) {
            this.setState({ checkedColor }, () => {
                this.checkedTheme = theme;
                this.getAllData();
            });
        } else {
            Notice({
                status: "warning",
                msg: langCheck('0000PUB-000416'), //多语-全局或集团已统一设置，不支持修改
            });
        }

    }
    //获取背景设置返回值并请求接口 
    getBackgroundObjAndAjax = (value, type) => {
        this.setState({ backgroundObject: value }, () => {
            // if (type === 'bdtype') return;
            this.getAllData();
        });
    }
    // 单独的获取背景设置返回值
    getBackgroundObj = value => {
        this.setState({ backgroundObject: value });
    }
    getBgColorArr = obj => {
        this.setState({ bgColorArr: obj });
    }
    // handleZoomSelect = (value) => {
    //     document.body.style.zoom = value;
    //     let ifrs = Array.from(document.querySelectorAll('#iframe'))
    //     ifrs.forEach((ifr, index) => {
    //         ifr.contentDocument.body.style.zoom = 0.8;
    //     })
    //     this.setState({
    //         zoomVal: value
    //     });
    //     setStore("zoom", value);
    // }
    /**
    * 更换主题皮肤 背景设置
    */
    getAllData = () => {
        const { checkedColor } = this.state;
        const { pk_customtheme, name } = this.checkedTheme;
        Ajax({
            url: "/nccloud/platform/appregister/addthemecolor.do",
            data: {
                color: checkedColor,
                name,
                pk_customtheme,
            },
            info: {
                name: langCheck("0000PUB-000258") /* 国际化处理： 主题设置*/,
                action: langCheck("0000PUB-000340"), /* 国际化处理： 回写主题设置*/
            },
            noNeedShowError: true,
            success: ({ data }) => {
                if (data.success && data.data) {
                    this.setColorArr(checkedColor);
                    this.setState({ checkedColor });
                    const nccColor = pk_customtheme ? 'mixin' : colorMap[checkedColor];
                    const { name, color } = data.data;
                    this.props.setThemeColor({ type: nccColor, name, color, pk_customtheme }); //设置 store主题色
                    // localStorage存颜色
                    setStore("nccColor", nccColor);
                    // 更换body class
                    setBodyClass({ themeType: nccColor });
                    window.nccColor = nccColor;
                    // 去掉应用成功的提示
                    // if (type !== 'bdtype') {
                    //     Notice({
                    //         status: "success",
                    //         msg: langCheck(
                    //             "Customize-000044",
                    //             "pages",
                    //             json
                    //         ) /* 国际化处理： 应用成功*/
                    //     });
                    // }
                    this.setState({ updateState: true });
                    // 更换 plantform css
                    setThemeAndIframe(nccColor, checkedColor);
                }
            },
            error: ({ data }) => {
                // debugger
                Notice({ status: "error", msg: data.error && data.error.message });
            },
        });
    };
    // 是否允许个人修改主题皮肤和背景设置
    getUsermodify = () => {
        Ajax({
            url: "/nccloud/platform/appregister/getcorpstylemodify.do",
            data: {},
            noNeedShowError: true,
            success: ({ data }) => {
                if (data.success) {
                    this.setState({ usermodify: data.data.usermodify });
                }
            },
        });

    }
    // collapse 回调
    onChangeCollapse = key => {
        const newKey = key ? key : '';
        this.setState({ collapseValue: newKey });
    }
    handleShade = () => {
        if (this.state.usermodify === null) { return; }
        Notice({
            status: "warning",
            msg: langCheck('0000PUB-000416'), //多语-全局或集团已统一设置，不支持修改
        });
    }

    //同步bip主题颜色
    syncBipTheme = () => {
        Ajax({
            url: `/nccloud/platform/appregister/syncthemeforbip.do`,
            info: { action: "同步BIP主题" },
        });
    }

    // 界面缩放
    renderZoomSetting() {
        const browser = Browser();
        if (browser === 'Firefox') { // 火狐不支持zoom
            return null;
        }
        const options = [
            { value: 0.8, text: '80%' },
            { value: 0.9, text: '90%' },
            { value: 1, text: '100%' },
            { value: 1.1, text: '110%' },
            { value: 1.2, text: '120%' },
            { value: 1.35, text: '135%' },
            { value: 1.5, text: '150%' },
        ];
        return <div className='link-box-item'>
            <div className='link-box-item-content'>
                <div className="link-box-item-left">
                    <i className='icon iconfont icon-fangda' />
                    <span>
                        {langCheck('0000PUB-000592' /* 界面缩放 */)}
                    </span>
                </div>
                <div className="link-box-item-right" style={{ width: '98px' }}>
                    <NCSelect
                        value={this.state.zoomVal}
                        className="zoom-select"
                        onSelect={value => {
                            setIframeZoom(value);
                            this.setState({ zoomVal: value });
                        }}
                    >
                        {
                            options.map(item => <NCOption value={item.value}>{item.text}</NCOption>)
                        }
                    </NCSelect>
                </div>
            </div>
        </div>;
    }

    render() {
        let { disturbVis, colorArr, collapseValue, backgroundObject, usermodify, colorNameMap, checkedColor = '' } = this.state;
        let { avatar, disturbInfo, userName, email, changeIsAccountSettingSpr, changeDrawer, theme } = this.props;
        const { color: themeColor } = theme;
        let showSpr = getStore('SHOWSPR');
        let { isopen, isdark, duetime, entrytime } = disturbInfo;
        let { bdtype, bgColor, bgImg } = backgroundObject;
        if (bgColorMap[bgColor]) {
            bgColor = bgColorMap[bgColor];
        }
        const smallImgUrl = checkedColor === defaultDepth ? defaultDepthSmall : checkedColor === defaultLight ? defaultLightSmall : '';
        const { color, name, pk_customtheme } = this.checkedTheme || {};
        const newName = pk_customtheme ? name : colorNameMap[color];
        //主题皮肤
        const skinSet = (<div className='link-box-item'>
            <div className='link-box-item-content'>
                <div className="link-box-item-left">
                    <i className='icon iconfont icon-zhutipifuicon' />
                    <span>
                        {langCheck("0000PUB-000288")}
                    </span>
                </div >
                <div className="link-box-item-right">
                    <div className="bg-color" style={checkedColor.indexOf('default') !== -1 ? { background: `url(${smallImgUrl}) center center` } : { backgroundColor: showColorMap[color] }}></div>
                    <span>{newName}</span>
                    <i className={`icon iconfont icon-gerenzhongxin-canshuxiala ${collapseValue === 'skinPanel' ? 'active' : ''} `} />
                </div>
            </div>
        </div>);
        // 背景设置
        const backgroundSet = (<div className='link-box-item'>
            <div className='link-box-item-content'>
                <div className="link-box-item-left">
                    <i className='icon iconfont icon-beijingtuicon' />
                    <span>
                        {langCheck("0000PUB-000398") /** 多语- 背景设置*/}
                    </span>
                </div>
                <div className="link-box-item-right">
                    {
                        bdtype === 'pic' ?
                            <div className="bg-img" style={{ background: `url(${backgroundImgs[bgImg]}) no-repeat center center` }}></div> :
                            <div className="bg-img" style={{ background: bgColor }}></div>
                    }

                    <i className={`icon iconfont icon-gerenzhongxin-canshuxiala ${collapseValue === 'backgroundPanel' ? 'active' : ''} `} />
                </div>
            </div>
            {/* {collapseValue !== 'backgroundPanel' && <div className="line"></div>} */}
        </div >);
        // let newNccColor = 'red';
        // if (getStore("nccColor") !== 'white' && getStore("nccColor") !== '') {
        //     newNccColor = window.nccColor
        // }
        const bannerBg = colorMap[themeColor] !== "black" ? bannerImg : bannerBlack;
        const avatorBanner = avatar ? avatar : bannerBg;
        return (
            < div className='drawer-content' fieldid='settings-area' >
                <div className={classNames("drawer-banner", { avatar: !!avatar })} style={{ background: `url(${avatorBanner}) no-repeat center center` }}></div>
                <div className="drawer-top">
                    <div className='drawer-exit'>
                        <div className='exitDiv' onClick={this.handleExit}>
                            <i
                                title={langCheck("0000PUB-000603")} /* "0000PUB-000603": "退出登录"*/
                                className='iconfont icon-tuichu'
                            />
                            <span>{langCheck("0000PUB-000603")}</span>
                        </div>
                    </div>
                    <div className='drawer-info'>
                        <div className='info'>
                            <div className='drawer-logo'>
                                <AvatarImg
                                    imgUrl={avatar}
                                />

                                {/* {
                                    !!avatar ? <img
                                        fieldid='userlogo_img' //自动化测试用标记
                                        src={avatar}
                                        alt='logo'
                                    /> : <p className="logo-content">{getAvatarName(userName)}</p>
                                } */}
                            </div>
                            <div className="drager-content">
                                <span className='name'>{userName}
                                    {/* <i
                                        className="iconfont icon-xiugaigerenxinxi"
                                        onClick={() => {
                                            this.handeleSkipPage("/ui", { n: langCheck("0000PUB-000147") });
                                        }}
                                    /> */}
                                </span>
                                {!!email && <span title={email} className='email'>{email}</span>}
                            </div>

                        </div>
                    </div>
                    <GroupSelection showIcon={false} groupSelectShow={true} />
                </div>
                <div className='drawer-link'>
                    <div className='link-box'>
                        <Collapse accordion
                            bordered={false}
                            onChange={this.onChangeCollapse}
                            defaultActiveKey={['skinPanel']}
                        >
                            <Panel
                                header={skinSet}
                                showArrow={false}
                                key='skinPanel'
                            >
                                {/* 主题皮肤 */}
                                {this.skinBox(colorArr)}
                            </Panel>
                            {
                                false && <Panel
                                    header={backgroundSet}
                                    showArrow={false}
                                    key='backgroundPanel'
                                >
                                    {/* 背景设置 */}
                                    {this.getBgSetting()}
                                </Panel>
                            }
                            {!usermodify && <div className='shade-bg' onClick={this.handleShade}></div>}
                        </Collapse>
                        {/* 界面缩放 */}
                        {/* {this.renderZoomSetting()} */}
                        <div
                            className='link-box-item'
                            onClick={() => {
                                console.log(GetQuery(this.props.location.search));
                                this.handeleSkipPage("/subjectSetting", {
                                    n: langCheck("0000PUB-000148"),
                                    type: 'accountSettings',
                                });
                            }}
                        >
                            <div className='link-box-item-content'>
                                <div className="link-box-item-left">
                                    {/* 个性化设置 */}
                                    <i className='icon iconfont icon-gexinghuashezhi' />
                                    <span>
                                        {langCheck("0000PUB-000148") /** 多语 - 个性化设置  */}
                                    </span>
                                </div>
                                {/* <div className="link-box-item-right">
                                <i className='icon iconfont icon-gerenzhongxin-canshuxiala' />
                            </div> */}
                            </div>
                        </div>
                        {/* <p
                            className="subject-setting"
                            onClick={() => {
                                this.handeleSkipPage("/subjectSetting", {
                                    n: langCheck("0000PUB-000148"),
                                    type: 'accountSettings',
                                });
                            }}>
                            {langCheck("0000PUB-000415") 多语 - 更多个性化设置 
                        </p> */}
                        <div
                            className='link-box-item'
                            // 账户设置
                            onClick={() => {
                                this.handeleSkipPage("/ui", { n: langCheck("0000PUB-000147") });
                            }}
                        >
                            <div className='link-box-item-content'>
                                <div className="link-box-item-left">
                                    {/* 账户设置 */}
                                    <i className='icon iconfont icon-a-zhanghushezhi3x' />
                                    <span>
                                        {langCheck("0000PUB-000147") /** 多语 - 账户设置  */}
                                    </span>
                                </div>
                                {/* <div className="link-box-item-right">
                                <i className='icon iconfont icon-gerenzhongxin-canshuxiala' />
                            </div> */}
                            </div>
                        </div>

                        {/* </div> */}
                        {/* <div className='link-box'> */}
                        <div
                            className='link-box-item'
                            onClick={() => {
                                this.handeleSkipPage("/c", {
                                    n: langCheck("0000PUB-000399"), /**多语 - 业务设置    */
                                });
                            }}
                        >
                            <div className='link-box-item-content'>
                                <div className="link-box-item-left">
                                    {/* 业务设置 */}
                                    <i className='icon iconfont icon-yewushezhiicon' />
                                    <span>
                                        {langCheck("0000PUB-000399") /** 多语 - 业务设置  */}
                                    </span>
                                </div>
                                {/* <div className="link-box-item-right">
                                <i className='icon iconfont icon-gerenzhongxin-canshuxiala' />
                            </div> */}
                            </div>
                        </div>
                    </div>
                    <div className='link-box'>
                        <div className='link-box-item' onClick={this.onAppNavClick}>
                            <div className='link-box-item-content'>
                                <div className="link-box-item-left">
                                    <i className="icon iconfont icon-liuchengdaohangicon" />
                                    <span>
                                        {langCheck('0000PUB-000377')}
                                        {/* 国际化处理： 流程导航*/}
                                    </span>
                                </div>
                                {/* <div className="link-box-item-right">
                                <i className='icon iconfont icon-gerenzhongxin-canshuxiala' />
                            </div> */}
                            </div>
                        </div>
                    </div>
                    <div className='link-box'>
                        <div
                            className='link-box-item'
                            onClick={() => {
                                changeIsAccountSettingSpr(true);
                                changeDrawer(false);
                                this.setState({ update: true });
                            }}
                        >
                            <div className='link-box-item-content'>
                                <div className="link-box-item-left">
                                    {/* 录制spr 结束录制spr */}
                                    <i className='icon iconfont icon-luzhiicon' />
                                    <span>
                                        {showSpr ? langCheck("0000PUB-000120") : langCheck("0000PUB-000461")}
                                    </span>
                                </div>
                                <div className="link-box-item-right">
                                    <span>ctrl + ~</span>
                                </div>
                            </div>
                            {/* <div className="line"></div> */}
                        </div>
                        <div
                            className='link-box-item'
                        >
                            <div className='link-box-item-content'>
                                <div className="link-box-item-left">
                                    {/* 勿扰模式 */}
                                    <i className='icon iconfont icon-ncc-pt-wr' />
                                    <span>
                                        {langCheck("0000PUB-000312")}
                                    </span>
                                    <span
                                        className='disturbSettingBtn'
                                        onClick={e => {
                                            e.stopPropagation();
                                            this.setState({ disturbVis: !this.state.disturbVis });
                                        }}
                                    >
                                        {langCheck("0000PUB-000322")}
                                    </span>
                                </div>
                                <NCSwitch style={{ marginRight: '12px' }} checked={isopen} onChange={this.switchChange} />
                            </div>
                            {isopen && duetime && duetime !== "" && (
                                <p style={{ margin: '0px 0 16px 32px', color: '#808080' }}>
                                    {langCheck("0000PUB-000323")}
                                    {formatDatetime(duetime)}
                                    {langCheck("0000PUB-000324")}
                                </p>
                            )}
                        </div>
                    </div>
                    <div className='link-box'>
                        <div
                            className='link-box-item'
                            onClick={this.handleSupportClick}
                        >
                            <div className='link-box-item-content'>
                                <div className="link-box-item-left">
                                    <i className='icon iconfont icon-yongyoufuwuzhichi' />
                                    <span >
                                        {langCheck("0000PUB-000149")}
                                        {/* 国际化处理： 用友服务支持*/}
                                    </span>
                                </div>
                            </div>
                            {/* <div className="line"></div> */}
                        </div>
                        <div
                            className='link-box-item'
                            onClick={() => {
                                this.handeleSkipPage("/log", {
                                    n: langCheck("0000PUB-000152") /* 国际化处理： 个人日志*/,
                                    c: "10220PLOGG",
                                });
                            }}>
                            <div className='link-box-item-content'>
                                <div className="link-box-item-left">
                                    <i className='icon iconfont icon-gerenrizhi1' />
                                    <span>
                                        {langCheck("0000PUB-000152")}
                                        {/* 国际化处理： 个人日志*/}
                                    </span>
                                </div>
                                {/* <div className="link-box-item-right">
                                <i className='icon iconfont icon-gerenzhongxin-canshuxiala' />
                            </div> */}
                            </div>
                        </div>
                    </div>
                </div>
                <HotKeysModal
                    container={document.body}
                    closable={true}
                    title={langCheck("0000PUB-000322") /* 国际化处理： 设置*/}
                    minWidth={400}
                    minHeight={200}
                    size='sm'
                    visible={disturbVis}
                    wrapClassName='disturbModal'
                    onOk={this.disturbOk}
                    onCancel={this.disturbCancel}
                    okText={langCheck("0000PUB-000001")} /* 国际化处理： 确定*/
                    cancelText={langCheck("0000PUB-000000")} /* 国际化处理： 取消*/
                    fieldid='disturb'
                    titleFieldid="disturb-setting"
                >
                    <div className="disturbLink">
                        {/* NCC-86901 新需求，该处提示信息不折行，改为上面显示 */}
                        {/*国际化处理： 选择后，会自动将颜色调整，可助您更专注于内容*/}
                        {/* <Row className="disturb-item">
                            <Col offset={1} span={22}>
                                <Alert
                                    message={
                                        langCheck(
                                            "0000PUB-000336",
                                        )
                                    }
                                    banner
                                />
                            </Col>
                        </Row> */}
                        {/* 国际化处理： 同时开启暗色模式：*/}
                        {/* <Row className="disturb-item">
                            <Col className="disturb-label" offset={1} span={8}>{langCheck("0000PUB-000325")}</Col>
                            <Col className="disturb-wrapper" span={14}>
                                <NCCheckbox onChange={this.checkboxChange} checked={isdark} className="disturb-checkbox" />
                            </Col>
                        </Row> */}
                        <Row className="disturb-item">
                            <Col className="disturb-label" offset={1} span={8}>{langCheck("0000PUB-000332") /* 国际化处理： 生效时间*/}</Col>
                            <Col className="disturb-wrapper" span={14}>
                                <NCSelect
                                    defaultValue={entrytime || "0.5"}
                                    style={{ width: 120 }}
                                    onChange={this.selectChange}
                                    getPopupContainer={() => document.body}
                                >
                                    <NCOption value='24'>{langCheck("0000PUB-000327") /* 国际化处理： 至明天*/}</NCOption>
                                    <NCOption value='0.5'>{langCheck("0000PUB-000328") /* 国际化处理： 30分钟*/}</NCOption>
                                    <NCOption value='1'>{langCheck("0000PUB-000329") /* 国际化处理： 1小时*/}</NCOption>
                                    <NCOption value='2'>{langCheck("0000PUB-000330") /* 国际化处理： 2小时*/}</NCOption>
                                    <NCOption value='5'>{langCheck("0000PUB-000331") /* 国际化处理： 5小时*/}</NCOption>
                                </NCSelect>
                            </Col>
                        </Row>
                    </div>

                </HotKeysModal>
            </div >
        );
    }
}

AccountSettings.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    avatar: PropTypes.string.isRequired,
    backgroundState: PropTypes.string.isRequired,
    userName: PropTypes.string.isRequired,
    changeDrawer: PropTypes.func.isRequired,
    changeIsAccountSettingSpr: PropTypes.func.isRequired,
    changeBgState: PropTypes.func.isRequired,
};

export default connect(
    state => ({
        isOpen: state.appData.isOpen,
        avatar: state.appData.avatar,
        userName: state.appData.userName,
        backgroundState: state.appData.backgroundState,
        is_cloud_register: state.appData.is_cloud_register,
        disturbInfo: state.appData.disturbInfo,
        groupId: state.appData.groupId,
        theme: state.appData.theme,
        email: state.appData.email,
    }),
    {
        changeDrawer,
        setDisturbMode,
        changeIsAccountSettingSpr,
        changeBgState,
        setThemeColor,
    },
)(withRouter(AccountSettings));
